module.exports = __webpack_public_path__ + "static/media/canais-2.f9b7cd0f.jpg";